import React, { useEffect, useState } from "react";
import Home from "../Home/Home";
import Footer from "../../common/Footer";
import InventoryPager from "./components/InventoryPager";
import Filter from "./components/Filter";
import CarSection from "./components/CarSection";
import Header from "../../common/Header";
import ExternalScripts from "../../common/ExternalScripts";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../axiosInstance";
import axios from "axios";

const Inventory = () => {
  const navigate = useNavigate()
  const [loading,setLoading] = useState(false)
  const [error,setError]  = useState("")
  const [inventories,setInventories] = useState([])
  const [limit,setLimit] = useState(20)
  const [page,setPage] = useState(1)
  const [totalItems,setTotalItems] = useState('')
  const [totalPages,setTotalPages] = useState("")
  const [fields,setFields] = useState({})
  const [field,setField] = useState({
    company:"",
    year:"",
    fuelType:"",
    transmission:""
  }) 
  const getAllInventory = async(page,limit,obj = {}) => {
    try {
      setLoading(true)
      setError("")
      const {company = "",year = "",transmission = "",fuelType = ""} = obj
      const response = await axiosInstance.get(`/api/public/getAllInventory`,{
        params:{page,limit,company,year,transmission,fuelType}
      })
      console.log(response?.data?.message);
      setLimit(response?.data?.limit);
      setTotalItems(response?.data?.totalItems)
      setTotalPages(response?.data?.totalPages)
      setInventories(response?.data?.data);
    } catch (error) {
       if (axios.isAxiosError(error)) {
        if (error.response) {
          const msg = error.response.data?.message || error.response.data?.error || "Something went wrong on the server.";
          setError(msg);
        }
        else if (error.request) {
          setError("No response from server. Please check your internet connection.");
        }
        else {
          setError(error.message || "Unexpected error occurred.");
        }
      } else {
        setError("An unexpected error occurred.");
      }
    } finally{
      setLoading(false)
    }
  }
  const getAllFields = async() => {
    try {
      setLoading(true)
      setError("")
      const response = await axiosInstance.get(`/api/public/getAllFields`)
      setFields(response?.data?.data);
    } catch (error) {
       if (axios.isAxiosError(error)) {
        if (error.response) {
          const msg = error.response.data?.message || error.response.data?.error || "Something went wrong on the server.";
          setError(msg);
        }
        else if (error.request) {
          setError("No response from server. Please check your internet connection.");
        }
        else {
          setError(error.message || "Unexpected error occurred.");
        }
      } else {
        setError("An unexpected error occurred.");
      }
    } finally{
      setLoading(false)
    }
  }
  useEffect(()=>{
    getAllFields()
    getAllInventory(page,limit)
  },[navigate,page,limit])
  
  return (
   <div className='boxcar-wrapper' style={{backgroundColor:"#050B20"}} >
       <div style={{paddingBottom:"220px"}} >
      <Header preclass="normal"  />
      </div>
      <ExternalScripts/>
      {/* <InventoryPager field = {field} page = {page} limit = {limit} getAllInventory = {getAllInventory} setField = {setField} fields = {fields} loading = {loading} /> */}
      {/* <Filter/> */}
      <CarSection page = {page} limit = {limit} setPage = {setPage} getAllInventory = {getAllInventory} totalItems = {totalItems} totalPages = {totalPages} inventories = {inventories} companies={fields?.companies || []} loading = {loading} error = {error}/>
      <Footer />
    </div>
  );
};

export default Inventory;
